import React from 'react'

import classNames from 'classnames'

import styles from './style.module.scss'

interface NormalItemProps {
  item: any
  onClick?: (item: any) => void
  onClickExt?: (item: any) => void
  wrapper?: {
    elem: any
    props: any
  }
  classNames?: string
  style?: React.CSSProperties
  testId?: string
}

interface NormalItemState {}

class NormalItem extends React.Component<NormalItemProps, NormalItemState> {
  state: NormalItemState = {}

  componentDidMount() {}

  componentWillUnmount() {}

  onClick = () => {
    const { item, onClick, onClickExt } = this.props
    const itemClone = {
      ...item,
    }
    if (itemClone.type == null) {
      itemClone.type = 'normal'
    }
    // console.log(' onClick - ', itemClone)
    if (onClickExt != null) {
      onClickExt(itemClone)
    } else if (onClick != null) {
      onClick(itemClone)
    }
  }

  render() {
    const { wrapper, item, classNames: cnames, style, testId } = this.props
    const { icon, label } = item

    const iconElem = icon != null ? <div className={classNames(styles.icon)}>{icon}</div> : null

    if (wrapper != null) {
      const Wrapper = wrapper.elem
      return (
        <Wrapper {...wrapper.props} onConfirm={this.onClick} onOk={this.onClick}>
          <div
            className={classNames(styles.normalItem, styles.selectorItem, cnames)}
            style={style}
            data-testid={testId}
          >
            {iconElem}
            <div className={classNames(styles.label)}>{label}</div>
          </div>
        </Wrapper>
      )
    }
    return (
      <div
        className={classNames(styles.normalItem, styles.selectorItem, cnames)}
        style={style}
        onClick={this.onClick}
        data-testid={testId}
      >
        {iconElem}
        <div className={classNames(styles.label)}>{label}</div>
      </div>
    )
  }
}

export default NormalItem
